import AlertTitle from '@mui/material/AlertTitle'
import Alert from '@mui/material/Alert'
import { useEffect, useState } from 'react'
import { LOGIN_SERVICE } from '../../Constants'

const CountdownToRedirect = (): JSX.Element => {

  const [seconds, setSeconds] = useState(10)

  useEffect(() => {
    let timer: NodeJS.Timeout

    if (seconds > 0) {
      timer = setTimeout(() => {
        setSeconds(seconds - 1)
      }, 1000)
    } else {
      window.location.replace(LOGIN_SERVICE)
    }

    return () => clearTimeout(timer)
  }, [seconds])

  return (
    <Alert severity='info' sx={{textAlign: 'left'}}>
      <AlertTitle aria-live='polite'>
        Taking you to your account in{' '}
        <strong>
          {seconds} seconds.
        </strong>
      </AlertTitle>
      Can&#39;t wait?{' '}
      <a href={LOGIN_SERVICE}>
        Take me to my account now!
      </a>
    </Alert>
  )
}

export default CountdownToRedirect
